<template>
  <div class="activity">
    <div class="banner">
      <img class="banner-img" :src="poster" alt="" />
      <div class="banner-content">
        <h2>{{ name }}</h2>
        <div class="act-infos">
          <div v-if="type == 0" class="status ing">进行中</div>
          <div v-if="type == 1" class="status red">已结束</div>
          <div v-if="type == 2" class="status end">未开始</div>
          <div class="act-infos-lst">
            <div
              :class="['lst-item', item.lnkFn ? 'link' : '']"
              v-for="(item, i) in infosList"
              :key="i"
            >
              <img v-if="!item.lnkFn" :src="item.ico" alt="" />
              <p>{{ item.txt }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="affairsQuery" v-if="!TENANTID || TENANTID==0" @click="getaffairsQuery">
      <van-image width="100%" height="100%" :src="Queryicon" />
    </div> -->
    <div class="act-attention">
      <div class="act-intro">
        <sign-title title="活动介绍" :simplicity="true" />
        <div class="intro-txt" v-html="intro"></div>
      </div>
    </div>
    <van-popup
      v-model="unitShow"
      closeable
      close-icon="arrow-down"
      close-icon-position="top-right"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="unit-lst-wrap">
        <div class="unit-lst" v-html="unitList"></div>
      </div>
    </van-popup>
    <div class="contribute" @click="toApplyPage" v-if="role === 0">
      <van-button
        size="large"
        color="linear-gradient(to right, #5DD682, #5AFF8E)"
        >马上报名</van-button>
    </div>
  </div>
</template>

<script>
import SignTitle from "@/components/pub/SignTitle.vue";
import { activityDetail } from "@/utils/api/home";
import { localStorageGetItem } from "@/utils/auth";
export default {
  components: {
    "sign-title": SignTitle
  },
  data() {
    return {
      Queryicon: require("@/assets/images/active/botton_zixun.png"),
      // 角色
      role: 0,
      // 活动简介
      intro: ``,
      // 活动流程日期
      infosList: [],
      // 单位显示
      unitShow: false,
      // 单位列表
      unitList: ``,
      // 活动名称
      name: "",
      // 互动海报
      poster: null,
      // 活动状态
      type: 0,
      activityId: this.$route.query.activityId,
      TENANTID:0,
    };
  },
  mounted() {
    this.TENANTID = localStorageGetItem("TENANT-ID") || "0";
    this.role = this.$store.state.role;
    if (this.$route.query.activityId != undefined) {
      this.getDetail();
      return;
    }
    const infos = JSON.parse(window.localStorage.getItem("active_infos_data"));
    if (!infos) {
      this.$router.replace("/");
    }
    this.pushData(infos);
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "Login") {
      next({ name: "HomeIndex" });
    } else {
      next();
    }
  },
  methods: {
    showUnit() {
      this.unitShow = true;
    },
    tagetFn(fnName) {
      this[fnName]();
    },
    pushData(infos) {
      this.intro = infos.synopsis;
      this.name = infos.name;
      this.poster = infos.posterUrl;
      this.type = infos.typeId;
      this.infosList.push(
        {
          ico: require("../../assets/images/home/act-txt-ico1.png"),
          txt: `投稿时间：${infos.startTime} 至 ${infos.endTime}`
        },
        {
          ico: require("../../assets/images/home/act-txt-ico2.png"),
          txt: `评审时间：${infos.startAuditTime} 至 ${infos.endAuditTime}`
        }
      );
    },
    getDetail() {
      activityDetail(this.activityId).then((res) => {
        if (res.success) {
          var infos = res.data;
          this.pushData(infos);
          window.localStorage.setItem(
            "active_infos_data",
            JSON.stringify(infos)
          );
        }
      });
    },
    toApplyPage() {
      if (this.type == 1) this.$root.$toast.fail("报名已结束");
      else if (this.type == 2) this.$root.$toast.fail("报名未开始");
      else {
        this.$router.replace("/home/activityapply");
      }
    },
    /**
     * @description: 跳转赛务查询页面
     * @author: wangxiaoheng
     */
    getaffairsQuery() {
      this.$router.replace("/home/affairsQuery");
    }
  }
};
</script>

<style lang="scss" scoped>
.activity {
  padding-bottom: 100px;
  .banner {
    width: 100%;
    max-width: 10rem;
    position: relative;
    overflow: hidden;
    padding-bottom: 10px;
    .banner-img {
      width: 100%;
      height: 160px;
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
    }
    .banner-content {
      position: relative;
      margin: 0 auto;
      width: 100%;
      margin-top: 103px;
      z-index: 5;
      padding: 0 12px;
      min-height: 0px;
      width: 335px;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      padding-bottom: 10px;
      box-shadow: 0px 2px 5px rgba(5, 75, 27, 0.2);
      h2 {
        min-height: 28px;
        line-height: 28px;
        color: #000;
        margin: 0;
        margin-top: 12px;
        font-weight: 900;
        font-size: 20px;
      }
      .act-infos {
        margin-top: 4px;
        .status {
          font-size: 12px;
          line-height: 16px;
          height: 16px;
          background-color: #6cdd8f;
          color: #fff;
          text-align: center;
          border-radius: 0 8px 0 8px;
          width: 46px;
          &.end {
            background-color: #eee;
          }
          &.red {
            background-color: red;
          }
        }
        .act-infos-lst {
          .lst-item {
            display: flex;
            line-height: 30px;
            font-size: 12px;
            color: #999999;
            align-items: center;
            height: 30px;
            p {
              font-size: 20px;
              transform: scale(0.5) translateX(-50%);
              min-width: 588px;
              text-align: left;
            }
            &.link {
              font-size: 14px;
              color: #5eaaff;
              line-height: 14px;
              height: 14px;
              p {
                font-size: 12px;
                transform: scale(1);
                min-width: 294px;
                text-align: left;
              }
            }
            img {
              margin-right: 3px;
              width: 16px;
              width: 16px;
            }
          }
        }
      }
    }
  }
  .act-attention {
    background-color: #fff;
    padding: 0 20px;
    text-align: left;
    margin-bottom: 80px;
    .act-intro {
      line-height: 22px;
      font-size: 14px;
      color: #999;
    }
  }
  .unit-lst-wrap {
    height: 100%;
    overflow-y: scroll;
    margin: 60px 0;
    padding: 0 36px;
  }
  .unit-lst {
    line-height: 22px;
    font-size: 14px;
    color: #999;
    text-align: left;
    padding-bottom: 100px;
  }
  .contribute {
    text-align: center;
    color: #16d77a;
    background-color: unset;
    position: fixed;
    bottom: 50px;
    display: flex;
    width: 100%;
    justify-content: center;
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
      box-shadow: 0 10px 10px #0002;
    }
  }
}
.affairsQuery {
  position: fixed;
  width: 94px;
  height: 46px;
  right: 0;
  top: 340px;
}
.intro-txt{
  white-space: pre-wrap;
}
</style>
<style lang="scss">
.activity {
  .van-popup {
    border-radius: 20px 20px 0 0;
    overflow-y: hidden;
    .van-icon {
      right: calc((100% - 16px) / 2);
      font-size: 16px;
      &::after {
        content: "";
        position: absolute;
        left: -3px;
        top: -3px;
        height: 20px;
        width: 20px;
        box-sizing: content-box;
        border: 1px solid #c8c9cc;
        border-radius: 50%;
      }
    }
  }
}
</style>
